import IOSDatePicker from "@/components/IOSDatePicker";
import { useTranslation } from "react-i18next";
import IconClose from "@/assets/icons/close.svg?react";
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Label } from "@/components/ui/label";
import { useCallback, useState } from "react";
import { cn } from "@/lib/utils";
import dayjs from "dayjs";
import BaseButton from "@/components/base/button/BaseButton";

interface DatePickerDrawerProps {
  onValueChange?: (value: Date | string) => void;
  value?: Date | string | undefined;
}

const DatePickerDrawer = ({ onValueChange, value }: DatePickerDrawerProps) => {
  const { t } = useTranslation();
  // const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [_value, _setValue] = useState<Date | string | undefined>(
    value ?? undefined
  );

  const handleDateChange = useCallback((date: Date) => {
    _setValue(date);
  }, []);

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <div className="space-y-2">
          <Label>{t("birthday")}</Label>
          <button
            type="button"
            className={cn(
              "bg-white/08 items-center flex h-11 w-full rounded-10 border border-input px-4 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-within:border-[#FBC76C] focus:bg-[#101017]",
              {
                "text-[#58585D]": !value,
              }
            )}
          >
            {value ? dayjs(value).format("DD/MM/YYYY") : "--/--/----"}
          </button>
        </div>
      </DrawerTrigger>
      <DrawerContent data-vaul-no-drag>
        <DrawerHeader className="flex items-center justify-between">
          {t("birthday")}

          <DrawerClose>
            <IconClose className="size-6 text-gray-1 cursor-pointer" />
          </DrawerClose>
        </DrawerHeader>
        <DrawerBody>
          <div className="pb-safe-bottom">
            <IOSDatePicker value={_value} onValueChange={handleDateChange} />
            <DrawerClose className="w-full">
              <BaseButton
                type="button"
                className="w-full"
                text={t("save")}
                onClick={() => {
                  if (_value) {
                    onValueChange?.(_value);
                  }
                }}
              />
            </DrawerClose>
          </div>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default DatePickerDrawer;
